import type { KnownTrackingLabels } from '@shared/tracking/TrackingLabels';

export function getPageViewTracking(
    historic: boolean,
    experimentIds: string[] = [],
    featureLabels: Partial<KnownTrackingLabels> = {},
) {
    const pageCluster = document.documentElement.dataset['pagecluster'] || 'UNKNOWN';

    const pageViewTracking: Partial<KnownTrackingLabels> = {
        ...featureLabels,
        san_ListEventType: 'tilelistview',
        ot_PageCluster: pageCluster,
    };

    if (historic) pageViewTracking.san_Interaction = 'browser_navigation';

    if (experimentIds.length) {
        pageViewTracking['wk.san_ReptileExperimentSegment'] = experimentIds;
    }

    return pageViewTracking;
}
